import {
	ChangeDetectionStrategy,
	Component,
	Input,
	Signal,
	WritableSignal,
	computed,
	input,
	signal
} from '@angular/core';
import { stringHelper } from 'lib/helpers/string-helper.class.js';
import { CoreComponent } from 'lib/ui/core/core.component.js';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'lib-shorten-text',
    templateUrl: 'shorten-text.component.html',
    styleUrls: ['shorten-text.component.scss'],
    standalone: false
})
export class ShortenTextComponent extends CoreComponent {
	private readonly defaultWrapLength = this.isMobileView() ? 128 : 256;

	public readonly text = input.required<string>();
	public readonly wrapLength = input<number>();
	public readonly disableShowMoreOrLessButton = input<boolean>(false);

	public readonly calculatedWrapLength: Signal<number> = computed(() => {
		const wrapLength = this.wrapLength();
		if (!wrapLength || wrapLength === 0) {
			return this.defaultWrapLength;
		}

		return wrapLength;
	});

	public readonly showLessButton: Signal<boolean> = computed(() => {
		if (this.disableShowMoreOrLessButton()) {
			return false;
		}

		const text = this.text();

		if (!text) {
			return false;
		}

		if (this.showFullText()) {
			return true;
		}

		return false;
	});

	public readonly showMoreButton: Signal<boolean> = computed(() => {
		if (this.disableShowMoreOrLessButton()) {
			return false;
		}

		const text = this.text();

		if (!text) {
			return false;
		}

		if (this.showFullText()) {
			return false;
		}

		if (text.length > this.calculatedWrapLength()) {
			return true;
		}

		return false;
	});

	public readonly showFullText: WritableSignal<boolean> = signal(false);

	public readonly displayedText: Signal<string | undefined> = computed(() => {
		const text = this.text();
		const calculatedWrapLength = this.calculatedWrapLength();

		if (!text) {
			return undefined;
		}

		if (this.showFullText()) {
			return text;
		}

		if (text.length > calculatedWrapLength) {
			// shorten string
			return stringHelper.shorten(text, calculatedWrapLength, true);
		}

		return text;
	});

	constructor() {
		super();
	}

	shoreMore(): void {
		this.showFullText.set(true);
	}

	showLess(): void {
		this.showFullText.set(false);
	}
}
